export default __webpack_public_path__ + "static/10-best-beaches-in-the-world-to-visit-6bbe180cf633799e366456a0d3698886.jpg";